var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "window-open",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Flat Line",
    className: "icon flat-line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "m 6,3 h 12 a 1,0.50074852 0 0 1 1,0.5007485 V 12.013473 H 5 V 3.5007485 A 1,0.50074852 0 0 1 6,3 Z",
    style: {
      fill: "#2ca9bc",
      strokeWidth: 1.41527
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M 12.209966,12.016493 12.083987,3.1109318 M 19.000004,12 H 4.9999964 M 3.0000007,20.999999 H 20.999999 m -1.999995,0 H 4.9999964 V 4.0000006 c 0,-0.5522841 0.4477141,-0.999999 0.9999979,-0.9999999 H 18.000006 c 0.552269,2.13e-5 0.999961,0.4477302 0.999961,0.9999999 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowOpen);
export default __webpack_public_path__ + "static/media/window-open.8974407a511e3816c6d796f257dc6124.svg";
export { ForwardRef as ReactComponent };